






import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class namecard extends Vue {
  content: object = {};
  get key() {
    return this.$route.params.key;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  getContent() {
    this.$Api.cms
      .getContentByDevice({ Key: this.key, IsMobile: this.isMobile })
      .then((result) => {
        this.content = result.CMS;
        console.log(result);
        if (!result.CMS.Id) {
          window.location.href = "/";
        }
        this.$nextTick(() => {
          if (result.CMS.Title) document.title = result.CMS.Title;
          (document.getElementsByName("keywords")[0] as any).content =
            result.CMS.SeoKeyword;
          (document.getElementsByName("description")[0] as any).content =
            result.CMS.SeoDesc;
          (
            document.getElementsByName("twitter:description")[0] as any
          ).content = result.CMS.SeoDesc;
          (document.getElementsByName("twitter:title")[0] as any).content =
            result.CMS.Title;
        });
      });
  }
  mounted() {
    this.getContent();
  }
}
